/**
 * Resolve Pokémon single finish (Matt / Holo / …) from cart line items.
 */
(() => {
  const finishLabelForCard = (finish) => {
    const key = String(finish || '').trim();
    if (!key) return '';
    if (key === 'Matt (Normal)' || key === 'normal') return 'Matt';
    return key;
  };

  const parseFinishFromSku = (sku) => {
    const raw = String(sku || '').trim().toUpperCase().replace(/-EN$/, '');
    if (raw.endsWith('-RH')) return 'Reverse Holo';
    if (raw.endsWith('-STD')) return 'Secret / Standard';
    if (raw.endsWith('-H')) return 'Holo';
    return '';
  };

  const finishCssModifier = (label) => {
    const key = String(label || '').trim().toLowerCase();
    if (key === 'holo') return 'holo';
    if (key === 'reverse holo') return 'reverse';
    if (key === 'secret / standard') return 'secret';
    return 'matt';
  };

  const isSingleCartItem = (item) => {
    const type = String(item?.product_type || '').toLowerCase();
    if (type.includes('einzelkarte')) return true;
    const sku = String(item?.sku || '').trim().toUpperCase();
    return sku.startsWith('PM-');
  };

  const resolveCartItemFinish = (item) => {
    if (!item || !isSingleCartItem(item)) return '';

    const fromSku = parseFinishFromSku(item.sku);
    if (fromSku) return finishLabelForCard(fromSku);

    const props = item.properties || {};
    for (const [key, value] of Object.entries(props)) {
      const k = String(key || '').toLowerCase();
      const v = String(value || '').trim();
      if (!v || k.startsWith('_')) continue;
      if (k.includes('finish') || k.includes('foil') || k === 'holo') {
        return finishLabelForCard(v);
      }
    }

    return 'Matt';
  };

  window.Kl24CartFinish = {
    finishLabelForCard,
    finishCssModifier,
    resolveCartItemFinish,
    isSingleCartItem,
  };
})();
